import { useEffect } from 'react';
import { useAppSelector } from '../../hooks';
import { getNavHeight } from '../utils/getNavHeight';
import setRootStyleProperty from '../../utils/setRootStyleProperty';
import { isWindowTopLevel } from '../utils/isWindowTopLevel';
import { isInIframe } from '../../overlayDisplayConfig/utils/isInIframe';
export function useHandleRootnavComponentDimensionUpdate() {
  const bannersDimensions = useAppSelector(state => state.navLayoutDimensionsState.rootNav.Banners);
  const toolbarDimensions = useAppSelector(state => state.navLayoutDimensionsState.rootNav.GlobalToolbar);
  const externalBannersDimensions = useAppSelector(state => state.navLayoutDimensionsState.externalNav.Banners);
  const verticalNavDimensions = useAppSelector(state => state.navLayoutDimensionsState.rootNav.VerticalNav);

  // Nav layout height update
  useEffect(() => {
    let navHeight = isWindowTopLevel() ? getNavHeight() : 0;
    try {
      if (isInIframe() && window.parent.hubspot &&
      // @ts-expect-error - No bender type in the hubspot window object yet
      window.parent.hubspot.bender &&
      // @ts-expect-error - No bender type in the hubspot window object yet
      window.parent.hubspot.bender.currentProject === 'LearningCenterUI') {
        const isAcademyNav = true;
        navHeight = getNavHeight(isAcademyNav);
      }
    } catch (_unused) {
      // no-op
    }
    setRootStyleProperty('--global-nav-height', `${navHeight}px`);
    setRootStyleProperty('--uicomponents-global-nav-height', `${navHeight}px`);
  }, [bannersDimensions, toolbarDimensions, externalBannersDimensions]);

  // Nav layout width update
  useEffect(() => {
    setRootStyleProperty('--global-nav-vertical-nav-width', `${verticalNavDimensions.width}px`);
  }, [verticalNavDimensions]);
}